import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import des traductions
import frCommon from './i18n/locales/fr/common.json';
import frNavigation from './i18n/locales/fr/navigation.json';
import frLogin from './i18n/locales/fr/login.json';
import frWorkspace from './i18n/locales/fr/workspace.json';
import frReview from './i18n/locales/fr/review.json';
import frCriteria from './i18n/locales/fr/criteria.json';
import frClients from './i18n/locales/fr/clients.json';
import frUsers from './i18n/locales/fr/users.json';
import frCriteriaView from './i18n/locales/fr/criteriaView.json';
import frReferentiel from './i18n/locales/fr/referentiel.json';
import frTaxonomie from './i18n/locales/fr/taxonomie.json';

import enCommon from './i18n/locales/en/common.json';
import enNavigation from './i18n/locales/en/navigation.json';
import enLogin from './i18n/locales/en/login.json';
import enWorkspace from './i18n/locales/en/workspace.json';
import enReview from './i18n/locales/en/review.json';
import enCriteria from './i18n/locales/en/criteria.json';
import enClients from './i18n/locales/en/clients.json';
import enUsers from './i18n/locales/en/users.json';
import enCriteriaView from './i18n/locales/en/criteriaView.json';
import enReferentiel from './i18n/locales/en/referentiel.json';
import enTaxonomie from './i18n/locales/en/taxonomie.json';

const SUPPORTED_LANGUAGES = ['fr', 'en'];

const resources = {
    fr: {
        common: frCommon,
        navigation: frNavigation,
        login: frLogin,
        workspace: frWorkspace,
        review: frReview,
        criteria: frCriteria,
        clients: frClients,
        users: frUsers,
        criteriaView: frCriteriaView,
        referentiel: frReferentiel,
        taxonomie: frTaxonomie,
    },
    en: {
        common: enCommon,
        navigation: enNavigation,
        login: enLogin,
        workspace: enWorkspace,
        review: enReview,
        criteria: enCriteria,
        clients: enClients,
        users: enUsers,
        criteriaView: enCriteriaView,
        referentiel: enReferentiel,
        taxonomie: enTaxonomie,
    }
};

const normalizeLanguage = (lang) => {
    if (!lang) return 'en';
    const short = lang.toLowerCase().split('-')[0];
    return SUPPORTED_LANGUAGES.includes(short) ? short : 'en';
};

const detectLanguage = () => {
    const storedLang = normalizeLanguage(localStorage.getItem('lang'));
    if (storedLang) return storedLang;

    const browserLang = normalizeLanguage(navigator.language);
    return browserLang || 'en';
};

const initialLanguage = detectLanguage();

// IMPORTANT : on persiste immédiatement la langue réelle au boot
localStorage.setItem('lang', initialLanguage);

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLanguage,
        fallbackLng: 'en',
        defaultNS: 'common',
        ns: [
            'common',
            'navigation',
            'login',
            'workspace',
            'review',
            'criteria',
            'clients',
            'users',
            'criteriaView',
            'referentiel',
            'taxonomie'
        ],
        interpolation: {
            escapeValue: false,
        },
        debug: process.env.NODE_ENV === 'development',
        saveMissing: process.env.NODE_ENV === 'development',
        missingKeyHandler: (lng, ns, key) => {
            if (process.env.NODE_ENV === 'development') {
                console.warn(`Missing translation: ${lng}.${ns}.${key}`);
            }
        }
    });

export const getCurrentLanguage = () => {
    return normalizeLanguage(i18n.resolvedLanguage || i18n.language || localStorage.getItem('lang'));
};

export const changeLanguage = async (lang) => {
    const normalized = normalizeLanguage(lang);
    localStorage.setItem('lang', normalized);
    document.documentElement.lang = normalized;
    await i18n.changeLanguage(normalized);
    return normalized;
};

// garde html lang à jour
document.documentElement.lang = getCurrentLanguage();

i18n.on('languageChanged', (lang) => {
    const normalized = normalizeLanguage(lang);
    localStorage.setItem('lang', normalized);
    document.documentElement.lang = normalized;
});

export default i18n;
